"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const string_utils_1 = require("@/common/string_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const recommendChoiceObj = {
    recommended_choice_08_cnt: {
        title: '귀여워요',
        icon: `${process.env.CDN_URL}/assets/images/cute_cat.webp`,
    },
    recommended_choice_09_cnt: {
        title: '인생 소비예요',
        icon: `${process.env.CDN_URL}/assets/images/life_changing_heart.webp`,
    },
    recommended_choice_02_cnt: {
        title: '퀄리티가 좋아요',
        icon: `${process.env.CDN_URL}/assets/images/quality_sparkles.webp`,
    },
    recommended_choice_10_cnt: {
        title: '기다린 보람이 있어요',
        icon: `${process.env.CDN_URL}/assets/images/rewarding_smile.webp`,
    },
    recommended_choice_11_cnt: {
        title: '친절하고 배려 있어요',
        icon: `${process.env.CDN_URL}/assets/images/approachable_cloud.webp`,
    },
    recommended_choice_12_cnt: {
        title: '상세 설명이 자세해요',
        icon: `${process.env.CDN_URL}/assets/images/detailed_pencil.webp`,
    },
    recommended_choice_01_cnt: {
        title: '배송 약속을 잘 지켜요',
        icon: `${process.env.CDN_URL}/assets/images/punctual_clock.webp`,
    },
    recommended_choice_03_cnt: {
        title: '포장이 꼼꼼해요',
        icon: `${process.env.CDN_URL}/assets/images/meticulous_package.webp`,
    },
};
const includeKeyArr = Object.keys(recommendChoiceObj);
function default_1({ channelId, updateLeaderReviewCount, isFondeeSpace, }) {
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const isGrid = isFondeeSpace && !maxWidth768;
    const [reviewCount, setReviewCount] = (0, react_1.useState)(0);
    const [recommendChoiceCount, setRecommendChoiceCount] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const getRecommendChoiceCount = () => {
        (0, api_1.getData)(`/api/v1/profile/${channelId}/info`)
            .then(res => {
            const { result } = res.data;
            setReviewCount(result.review_count);
            const choiceCount = Object.entries(result)
                .filter(([key]) => includeKeyArr.includes(key))
                .map(([key, value]) => ({ [key]: value }))
                .sort((a, b) => {
                const valueA = Object.values(a)[0];
                const valueB = Object.values(b)[0];
                return valueB - valueA;
            });
            setRecommendChoiceCount(choiceCount);
            setIsLoading(false);
            if (!!updateLeaderReviewCount) {
                updateLeaderReviewCount(result.review_count);
            }
        })
            .catch(error => {
            var _a, _b, _c, _d;
            const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
        });
    };
    (0, react_1.useEffect)(() => {
        getRecommendChoiceCount();
    }, []);
    const biggestCount = recommendChoiceCount.reduce((max, current) => {
        const value = Object.values(current)[0];
        return value > max ? value : max;
    }, 0);
    const maxCount = Math.max(40, Math.min((biggestCount * 3) / 2, 10000));
    const percentPerCount = Number((100 / maxCount).toFixed(2));
    const { t } = (0, react_i18next_1.useTranslation)();
    const skeletonArr = new Array(8).fill(0);
    const RectSkeleton = ({ sx }) => ((0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: sx }));
    if (isLoading)
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: { display: 'flex', flexDirection: 'column', rowGap: '14px' } }, { children: [(0, jsx_runtime_1.jsx)(RectSkeleton, { sx: { width: '100px', height: '24px', borderRadius: '3px' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                        display: isGrid ? 'grid' : 'flex',
                        gridTemplateColumns: '1fr 1fr',
                        flexDirection: 'column',
                        gap: '5px 20px',
                    } }, { children: skeletonArr.map((_, idx) => ((0, jsx_runtime_1.jsx)(RectSkeleton, { sx: { width: '100%', height: '40px', borderRadius: '6px' } }, `recommend_graph_skeleton_${idx}`))) }))] })));
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: { display: 'flex', flexDirection: 'column', rowGap: '14px' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3 gray-80" }, { children: `${t('마켓 리뷰')} ${reviewCount}${t('개')}` })), !!reviewCount ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                    display: isGrid ? 'grid' : 'flex',
                    gridTemplateColumns: '1fr 1fr',
                    flexDirection: 'column',
                    gap: '5px 20px',
                    overflowY: 'hidden',
                } }, { children: recommendChoiceCount.map((recommend, index) => {
                    const [recommendChoice, recommendCount] = Object.entries(recommend)[0];
                    const countPercent = recommendCount >= 9999
                        ? '100%'
                        : `${Number((percentPerCount * recommendCount).toFixed(2))}%`;
                    const { title, icon } = recommendChoiceObj[recommendChoice];
                    const parsedRecommendCount = recommendCount > 9999 ? '+9,999' : (0, string_utils_1.money)(recommendCount);
                    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-bg-light", css: {
                            position: 'relative',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '10px',
                            height: '40px',
                            padding: '0 14px',
                            borderRadius: '6px',
                        } }, { children: [(0, jsx_runtime_1.jsx)("div", { css: {
                                    position: 'absolute',
                                    left: 0,
                                    width: countPercent,
                                    minWidth: !!recommendCount ? '4px' : 0,
                                    height: '40px',
                                    borderRadius: '6px',
                                    backgroundColor: '#ffe9ca',
                                } }), (0, jsx_runtime_1.jsx)("img", { src: icon, css: { width: '24px', height: '24px', zIndex: 1 } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle5 gray-80", css: { flex: 1, zIndex: 1 } }, { children: t(title) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle5 gray-80", css: { zIndex: 1 } }, { children: parsedRecommendCount }))] }), `${recommendChoice}_${index}`));
                }) }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 gray-80", css: { paddingBottom: '240px' } }, { children: `${t('첫 번째 리뷰를 기다리고 있어요')} :)` })))] })));
}
exports.default = default_1;
